<template>
  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-card class="elevation-12">
                <v-toolbar color="#7E6990" dark flat>
                  <v-toolbar-title>ログイン</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-form ref="loginForm">
                    <v-text-field
                      label="ID (ユーザID@ドメインID)"
                      name="userid"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="model.userid"
                      :rules="useridRules"
                      required
                      color="purple darken-2"
                    ></v-text-field>

                    <v-text-field
                      id="password"
                      label="パスワード"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="model.password"
                      :rules="passwordRules"
                      required
                      color="purple darken-2"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <div id="message">{{ errorMessage }}</div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#7E6990"
                    @click="login"
                    :loading="loading"
                    id="login-btn"
                    dark
                    >Login</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer color="#7E6990" padless>
        <v-row justify="center" no-gutters>
          <v-btn
            v-for="link in links"
            :key="link.name"
            :href="link.to"
            color="white"
            text
            rounded
            class="my-2 text-capitalize"
            target="_blank"
            >{{ link.name }}</v-btn
          >
          <v-col
            class="accent-3 py-4 text-center white--text"
            color="#7E6990"
            cols="12"
          >
            {{ new Date().getFullYear() }} —
            <strong>TDC SOFT Inc. All rights reserved</strong>
          </v-col>
        </v-row>
      </v-footer>
    </v-app>
  </div>
</template>

<style>
#login-btn {
  min-width: 130px;
}
#message {
  vertical-align: middle;
  text-align: center;
  color: #ff5252 !important;
}
</style>
<script>
export default {
  data: () => ({
    loading: false,
    useridRules: [
      (v) => !!v || "ユーザIDは必須項目です。",
      (v) =>
        /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}$/.test(v) ||
        "ユーザIDの形式が正しくありません。",
    ],
    passwordRules: [(v) => !!v || "パスワードは必須項目です。"],
    model: {
      userid: "",
      password: "",
    },
    errorMessage: "　",
    links: [
      { name: "Styleflow", to: "https://www.styleflow.jp/kumade/cupflow" },
      {
        name: "プライバシーポリシー",
        to: "https://www.tdc.co.jp/company/hoshinindex/privacy_policy/",
      },
      {
        name: "ご利用規約",
        to: "https://www.styleflow.jp/kumade/html/index/tos_styleflow.html",
      },
      {
        name: "品質方針",
        to: "https://www.tdc.co.jp/company/hoshinindex/quality_policy/",
      },
      { name: "サポートサイト", to: "https://support.styleflow.jp/hc/ja" },
    ],
  }),

  methods: {
    login() {
      if (this.$refs.loginForm.validate()) {
        this.loading = true;
        this.$http
          .post("/token/login", this.model)
          .then((res) => {
            if (res.status == 200) {
              this.$store.dispatch("logininfo/login", {
                userid: res.data["userId"],
                username: res.data["userName"],
                domainid: res.data["domainId"],
                domainname: res.data["domainName"],
                accesslevel: res.data["accessLevel"],
              });
              this.$router.push({
                path:
                  "backuri" in this.$route.query &&
                  this.$route.query.backuri &&
                  this.$route.query.backuri.match(/^\//)
                    ? this.$route.query.backuri
                    : "/",
              });
            } else {
              this.loading = false;
              alert(Object.values(res.data.errors).join("\n"));
            }
          })
          .catch((error) => {
            this.loading = false;
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.errorMessage = error.response.data.message;
            } else {
              this.errorMessage = error;
            }
          });
      }
    },
  },
};
</script>
